import axios from "axios";
import * as types from "../constants";

const getScheduleAction = (scheduleData, isLive) => ({
	type: types.GET_SCHEDULE,
	scheduleData,
	isLive,
});

const getScheduleBeginAction = () => ({
	type: types.GET_SCHEDULE_BEGIN,
});

const getChannelsAction = channels => ({
	type: types.GET_CHANNELS,
	channels,
});

const getChannelsLiveStatsAction = stats => ({
	type: types.GET_CHANNELS_LIVE_STATS,
	liveStats: stats
});

const getScheduleHandle = async (loc_server, date) =>
{
	let gamesByDate = await axios(`${loc_server}schedule?format=json${date ? '&day=' + date : ''}`);

	if (date === undefined)
	{
		let prevGames = await axios(`${loc_server}schedule?format=json&day=${gamesByDate.data.previousDate}`);
		prevGames.data.games.forEach(game =>
		{
			if (game.gameState === 1)
			{
				gamesByDate.data.games.push(game);
			}
		})
	}
	return gamesByDate.data;
};

export const getSchedule = (date, isCheckGame = false) => (dispatch, getState) =>
{
	const {LOC_SERVER} = getState().Config;
	if (!isCheckGame)
	{
		dispatch(getScheduleBeginAction());
	}
	if (date === undefined && !isCheckGame)
	{
		dispatch(getChannels());
	}
	getScheduleHandle(LOC_SERVER, date).then(data =>
	{
		if(data.games.length > 0)
		{
			data.games = data.games.filter(item => item.blackout === undefined)
		}
		dispatch(getScheduleAction(data, date === undefined))
	});
};

const changeFilter = filter => ({
	type: types.CHANGE_FILTERS,
	filter,
});

export const changeFilterStats = (date, filter) => dispatch =>
{
	if (date !== null)
	{
		dispatch(getSchedule(date));
	}
	else
	{
		if (filter.gameState && filter.gameState === 1)
		{
			dispatch(getSchedule());
		}
	}
	dispatch(changeFilter(filter));
};

export const getChannels = () => (dispatch, getState) =>
{
	const {LOC_SERVER} = getState().Config;

	axios(`${LOC_SERVER}channels?format=json`).then(channels =>
	{
		dispatch(getChannelsAction(channels.data));
	});
};

let timer = null;
export const getChannelLiveProgram = netwoiprk => (dispatch, getState) =>
{
	if (timer !== null)
	{
		clearInterval(timer);
		timer = null;
	}
	const {LOC_EPG} = getState().Config;
	timer = setInterval(() =>
	{
		NEU.fetchJSONPFeed(`${LOC_EPG}current2.js?_=${Date.now()}`, 'handleCurrentEPGCallback').then(data =>
		{
			dispatch(getChannelsLiveStatsAction(data))
		})
	}, 1000 * (window.CURRENT_FEED_INTERVAL || 5));

	NEU.fetchJSONPFeed(`${LOC_EPG}current2.js?_=${Date.now()}`, 'handleCurrentEPGCallback').then(data =>
	{
		dispatch(getChannelsLiveStatsAction(data))
	})
	return () =>
	{
		if (timer !== null)
		{
			clearInterval(timer);
			timer = null;
		}
	}
}
let liveStatsInterval = null;
export const checkScheduleLiveStats = liveGames => (dispatch, getState) =>
{
	const {Config} = getState(), {SOLR_GAME} = Config, funcName = 'getScheduleStatsCallback';

	if (liveStatsInterval === null)
	{
		liveStatsInterval = setInterval(() =>
		{
			let liveGames = getState().schedule.games.filter(game => game.gameState === 1 || game.gameState === 0),
					ids = liveGames.map(game => game.id);

			if (!liveGames || liveGames.length === 0)
			{
				clearInterval(liveStatsInterval);
				liveStatsInterval = null;
				return;
			}

			NEU.fetchJSONPFeed(`${SOLR_GAME}usersearch?q=GAME_ID:("${ids.join('" "')}")&wt=json&rows=${ids.length}&json.wrf=${funcName}&fl=GAME_STATE,GAME_ID`, funcName).then(data =>
			{
				let hasNoChange = true;

				for (let i = 0, len = data.response.docs.length; i < len; i++)
				{
					let game = data.response.docs[i];

					hasNoChange = liveGames.some(_game => _game.id.toString() === game.GAME_ID.toString() && _game.gameState === game.GAME_STATE);

					if (!hasNoChange)
					{
						dispatch(getSchedule(undefined, true));
						break;
					}

				}
			})

		}, 1000 * (window.CURRENT_FEED_INTERVAL || 5))
	}
	return () =>
	{
		if (liveStatsInterval !== null)
		{
			clearInterval(liveStatsInterval);
			liveStatsInterval = null;
		}
	}
}